import Vivus from 'vivus';

const icons = [...document.querySelectorAll('.card-icon')];
const iconsGradient = [...document.querySelectorAll('.card-icon-gradient')];

icons.forEach((icon) => animateIcon(icon, {duration: 150}));
iconsGradient.forEach((icon) => animateIcon(icon, {duration: 100}));

/**
 * @param {HTMLElement} icon
 * @param {Vivus.VivusOptions} options
 */
function animateIcon(icon, options) {
  const vivus = new Vivus(icon, options);

  // Add event listeners if a parent element has registered for animation on hover
  const $hoverTarget = icon.closest('[data-animate-icon-hover]');

  $hoverTarget?.addEventListener('mouseenter', () => {
    const status = vivus.getStatus();
    if (status === 'end') {
      vivus.reset();
    }
    // Slightly faster playback on hover for greater sense of responsiveness
    vivus.play(2);
  });

  $hoverTarget?.addEventListener('mouseleave', () => {
    // Speed up playback if the user mouses out before animation has finished
    vivus.play(4);
  });
}
